import React, { FC } from "react";

import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ReadIcon, UnreadIcon } from "@/assets/icons";
import config from "@/config";
import { chatDateFormat } from "@/core/date";
import { sanitizeHtml } from "@/core/security";

import Attachment from "../ConversationThumbnail/ConversationThumbnail";
import { StyledAttachmentContainer } from "./styled";

type ConversationMessageMessageProps = {
    message: MyBrokerApi.ConversationMessage;
    conversationId: string;
    isArchived?: boolean;
};

const ConversationMessage: FC<ConversationMessageMessageProps> = ({ message, conversationId, isArchived = false }) => {
    const { i18n } = useTranslation();

    const messageFromMeLabel = message.fromMe ? "out" : "in";

    return (
        <>
            <div className={clsx(`message-${messageFromMeLabel}`, isArchived && "isArchived")}>
                <div className="message-timestamp">{chatDateFormat(message.timestamp, i18n.language)}</div>
                <div className="message" data-testid={`message-${message.id}`}>
                    <div className="conversation-message-title">{message.sender.name}</div>
                    <div
                        className="conversation-message"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(message.body),
                        }}
                    />
                    <div className="status-icon">{message.status === "read" ? <ReadIcon /> : <UnreadIcon />}</div>
                </div>
                {message.attachments && message.attachments.length > 0 && (
                    <StyledAttachmentContainer $isFromMe={message.fromMe}>
                        <div className="attachments-subcontainer">
                            {message.attachments?.map((attachment) => (
                                <Attachment
                                    type={attachment.type}
                                    key={`attachment-${attachment.id}`}
                                    alt={attachment.name}
                                    url={`${config.SPAPI_URL}/api/conversation/message/${conversationId}/${attachment.id}?thumbnail=true`}
                                />
                            ))}
                        </div>
                    </StyledAttachmentContainer>
                )}
            </div>
        </>
    );
};

export default ConversationMessage;
